import React, { useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import { ActionButton, DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { Card, Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { __MessageTypes, enum__BULK_PAYLOAD_TYPE_ID } from '../../../../common/Dictionaries';
import { formatNumber, getGridLocalization, isNullUndefined, isNullUndefinedOrEmpty, showMessage } from '../../../../common/Helpers';
import MessageBoxInfoComplex from '../../../../components/Common/Message/MessageBoxInfoComplex';
import PropTypes from 'prop-types';
import { DatePicker, Dropdown, Pivot, PivotItem, SpinnerSize, TooltipHost } from '@fluentui/react';
import JqxGrid, { jqx } from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid';
import { executeScrollMovementToFixLockRowOnEditCell } from '../../../../common/Helpers/JqxGridFilter';
import { action_updateEdpPrepareAmbiente, action_updateEdpPrepareDI, action_updateEdPPrepareForceGetAmbiente, action_updateEdPPrepareForceGetButtons, action_updateEdPPrepareForceGetHeader, action_updateEdPPrepareForceGetParties, action_updateEdPPrepareForceGetResult, action_updateEdpPrepareParties } from '../../../../reducers/actions/PAY/edpPrepareActions';
import './style.css'
import 'jqwidgets-scripts/jqwidgets/styles/jqx.light.css';
import { useCargarAmbiente } from '../../../../hooks/services/sPay/useOfEdPPrepare';
import { getEdPPrepare_PartiesList, Validar_Guardado_EP } from '../../../../services/sPay/edpConfig.service';
import CTextBox from '../../../../components/Common/CTextBox';
import CLabel from '../../../../components/Common/CLabel';
import moment from 'moment';
import Loading from '../../../../components/Templates/Site/Loading';
import i18next from 'i18next';
import MainAppContext from '../../../../MainAppContext';
import MessageBox from '../../../../components/Common/Message/MessageBox';
import { getEdPPayload, postValidateEdPDocument } from '../../../../services/Bulk/bulk.service';
import { addTransversalDocument } from '../../../../services/sBook/document.service';
import { envBlobDocumentUpload, envDocumentGetUrl, envDocumentValidate } from '../../../../services/Env/transversal.service';
import { FILE_MAX_SIZE } from '../../../../configurations/application.config';
const SidePanelIngresoEdP = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const numberValidDecimals = 10;

    const contextSite = useContext(MainAppContext);

    const {
        _formMode: formMode,
        _firsLoadParties: firsLoadParties,
        _firsLoadDI: firsLoadDI,
        _edpPrepareDIs: edpPrepareDIs,
        _edpPrepareParties: edpPrepareParties,
        _edpPrepareAmbiente: edpPrepareAmbiente,
        _edpPrepareHeader: edpPrepareHeader,
    } = useSelector((state) => state.edpPreparationState);

    const { 
        inputParam_ElementId = null,
        inputParam_EdPId = null,
        inputParam_IsPanelOpen = null,
        inputParam_SetterIsPanelOpen = null,
    } = props;

    const gridRefPartidas = useRef(null);
    const gridRefCantidadServicios = useRef(null);
    const gridRefDI = useRef(null);
    const [nroEp, setNroEp] = useState(null);
    const [fechaTipoCambio, setFechaTipoCambio] = useState(null);

    const fileInputRef = useRef(null);
    const [uploadInProgress, setUploadInProgress] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileUploaded, setFileUploaded] = useState(false);
    const [processedFile, setProcessedFile] = useState(null);
    const [documentId, setDocumentId] = useState(null);

    const [selectedPivotKey, setSelectedPivotKey] = useState("0");
    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });
    const [messageConfigUploadMassive, setMessageConfigUploadMassive] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    
    const [isExecutingAction, setIsExecutingAction] = useState(false);

    const [executeCargarAmbiente, setExecuteCargarAmbiente] = useState(true);
    useCargarAmbiente(inputParam_EdPId, executeCargarAmbiente, setExecuteCargarAmbiente)

    const onDismissPanel = () => {
        showMessage(setMessageConfig, false, null, null)
        inputParam_SetterIsPanelOpen && inputParam_SetterIsPanelOpen(false)
    };

    const onClosePanel = () => {
        onDismissPanel();
    };

    const onSelectPivotKey = (item, ev) => {
        try {
            const pivotKey = item.key.replace(".", "");

            setSelectedPivotKey(pivotKey)
        } catch (error) {
            
        }
    };

    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12} className="message-verybottom-panel-medium">
                        <MessageBoxInfoComplex
                            inputParam_Message={ messageConfig.message }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                            inputParam_ShowClose={true}
                        />
                    </Col>
                    <Col xl={12}>
                        <>
                        {
                                isExecutingAction === false &&
                                <>
                                    {
                                        edpPrepareAmbiente &&
                                        <>
                                            {
                                                (edpPrepareAmbiente.tiene_polinomio) &&
                                                <PrimaryButton className='mx-1' onClick={ onCalculateAdjustmentFactor }>{ t('data-lang-btn-calculateadjustmentfactor') }</PrimaryButton>
                                            }
                                            {
                                                edpPrepareAmbiente.habilitar_normalizar_polinomio &&
                                                <PrimaryButton className='mx-1' onClick={ onNormalizeAdjustmentFactor }>{ t('data-lang-btn-normalizeadjustmentfactor') }</PrimaryButton>
                                            }
                                            {
                                                !edpPrepareAmbiente.necesario_calcular_factor_reajuste ?
                                                <PrimaryButton className='mx-1' onClick={ onCalculateAndSave }>{ t('data-lang-btn-calculateandsave') }</PrimaryButton>
                                                :
                                                <PrimaryButton className='mx-1' disabled={true} onClick={ undefined }>{ t('data-lang-btn-calculateandsave') }</PrimaryButton>
                                            }
                                        </>
                                    }
                                    <DefaultButton className='mx-1' onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
                                </>
                            }
                        </>
                        <>
                            {
                                isExecutingAction === true &&
                                <Loading
                                    inputParam_Style={{marginTop: 0}}
                                    inputParam_ShowLoading={true}
                                    inputParam_ShowText={true}
                                    inputParam_Text={t('data-lang-lbl-executing')}
                                    inputParam_Position="unset"
                                    inputParam_Width="30px"
                                    inputParam_Height="30px"
                                    inputParam_Vertical={false}
                                    inputParam_EjecutingTextClass={"ps-4"}
                                />
                            }
                        </>
                    </Col>
                </Row>
    }

    const onCalculateAdjustmentFactor = () => {
        setIsExecutingAction(true);
        getEdPPrepare_PartiesList(inputParam_EdPId, true, false).then((response) => {
            if (response.data.succeeded) {
                const data = response.data.data;

                const mergedList = edpPrepareParties.map(item2 => {
                    const match = data.find(item1 => item1.id === item2.id);
                    return {
                        ...item2,
                        factoR_REAJUSTE_EP: item2.factoR_REAJUSTE_EP === null && match ? match.factoR_REAJUSTE_EP : item2.factoR_REAJUSTE_EP,
                    };
                });

                dispatch(action_updateEdpPrepareParties(mergedList));
                dispatch(action_updateEdPPrepareForceGetButtons(true));
                dispatch(action_updateEdPPrepareForceGetHeader(true));
                dispatch(action_updateEdPPrepareForceGetResult(true));
                dispatch(action_updateEdPPrepareForceGetAmbiente(true));

                edpPrepareAmbiente.necesario_calcular_factor_reajuste = false
                const aux_edpPrepareAmbiente = {...edpPrepareAmbiente}
                dispatch(action_updateEdpPrepareAmbiente(aux_edpPrepareAmbiente))

                showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                setIsExecutingAction(false)
            }
            else {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                setIsExecutingAction(false)
            }
        }).catch(() => {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            setIsExecutingAction(false)
        });
    }

    const onNormalizeAdjustmentFactor = () => {
        setIsExecutingAction(true)
        getEdPPrepare_PartiesList(inputParam_EdPId, true, true).then((response) => {
            if (response.data.succeeded) {
                const data = response.data.data;

                const mergedList = edpPrepareParties.map(item2 => {
                    const match = data.find(item1 => item1.id === item2.id);
                    return {
                        ...item2,
                        factoR_REAJUSTE_EP: item2.factoR_REAJUSTE_EP === null && match ? match.factoR_REAJUSTE_EP : item2.factoR_REAJUSTE_EP,
                    };
                });

                dispatch(action_updateEdpPrepareParties(mergedList))

                dispatch(action_updateEdPPrepareForceGetHeader(true));
                dispatch(action_updateEdPPrepareForceGetResult(true));
                dispatch(action_updateEdPPrepareForceGetButtons(true));
                dispatch(action_updateEdPPrepareForceGetAmbiente(true));

                showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                setIsExecutingAction(false)
            }
            else {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                setIsExecutingAction(false)
            }
        }).catch(() => {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            setIsExecutingAction(false)
        });
    }

    const prepareObjectToSave = () => {
        return {
            edp_id: inputParam_EdPId,
            l_partidas: edpPrepareParties,
            l_di: edpPrepareDIs,
            nro_ep: nroEp,
            dt_tipo_cambio: fechaTipoCambio,
            dt_hasta: null,
        }
    }

    const onCalculateAndSave = () => {   
        setIsExecutingAction(true)
        const objecToSave = prepareObjectToSave()
        Validar_Guardado_EP(objecToSave).then((response) => {
            if (response.data.succeeded) {
                if (response.data.data.result) {

                    dispatch(action_updateEdPPrepareForceGetHeader(true));
                    dispatch(action_updateEdPPrepareForceGetResult(true));
                    dispatch(action_updateEdPPrepareForceGetAmbiente(true));
                    dispatch(action_updateEdPPrepareForceGetButtons(true));

                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                }
                else {
                    if (response.data.data.l_validations.length > 0) {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, response.data.data.l_validations)
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    }
                }
                setIsExecutingAction(false)
            }
            else {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                setIsExecutingAction(false)
            }
        }).catch(() => {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            setIsExecutingAction(false)
        });
    }

    const validarSaldoNegativoContratoDialogo = () => {
        showMessage(setMessageConfig, true, __MessageTypes.INFO, "El contrato no puede quedar con saldo negativo.")
    }
    const validarSaldosNegativosConceptoPagoDialogo = () => {
        showMessage(setMessageConfig, true, __MessageTypes.INFO, "El contrato no permite saldos negativos en las partidas.")
    }
    const validarSaldosNegativosConceptoPagoDialogoCallBack = () => {
        showMessage(setMessageConfig, true, __MessageTypes.INFO, "El contrato no permite saldos negativos en las partidas.")
    }
    const validarSaldosNegativosMontoEPDialogoCallBack = () => {
        showMessage(setMessageConfig, true, __MessageTypes.INFO, "El Estado de Pago debe contener al menos una partida mayor que cero (0).")
    }
    const cancelarDialogo = () => {
        showMessage(setMessageConfig, true, __MessageTypes.INFO, "¿Desea salir sin guardar los cambios?")
    }

    const onCellPartidasValueChanged = (e) => {
        const newData = [...edpPrepareParties];

        newData.forEach((partie, index) => {
            if (e.args.rowindex === index) {
                partie[e.args.datafield] = e.args.value;
            }
        });

        dispatch(action_updateEdpPrepareParties(newData))
        executeScrollMovementToFixLockRowOnEditCell(gridRefPartidas);
    };

    const onCellDIValueChanged = (e) => {
        const rowsbounded = e.owner.source.records;
        dispatch(action_updateEdpPrepareDI(rowsbounded))

        executeScrollMovementToFixLockRowOnEditCell(gridRefDI);
    };

    const tipoTextoMap = (value) => {
        return value === 1 ? 'Deducciones' : 'Incrementos';
    };

    const setterNumeroEp = (controlValue, controlName) => {
        setNroEp(controlValue)
    };

    const handleDateChange = (date) => {
        const fecha = moment(date).format('MM/DD/YYYY');
        setFechaTipoCambio(fecha)
    };

    const cellsEditorRenderer = (rowIndex, cellValue, editor, cellText, width, height, auxListData, cellType, subType) => {
        switch (cellType) {
            case 'textbox':
                switch (subType) {
                    case "currency":
                        editor.jqxNumberInput({
                            spinMode: 'simple',
                            width: width,
                            spinButtons: false,
                            symbol: '$',
                            groupSeparator: '.',
                            decimalSeparator: ',',
                            digits: 15, 
                            decimalDigits: numberValidDecimals,
                            max: 999999999999999,
                        });
                        break;
                    case "number":
                        editor.jqxNumberInput({
                            width: width,
                            spinButtons: true,
                            groupSeparator: '.',
                            decimalSeparator: ',',
                            digits: 15, 
                            decimalDigits: numberValidDecimals,
                            max: 999999999999999,
                        });
                        break;
                    case "numberNoDecimal":
                        editor.jqxNumberInput({
                            decimalDigits: 0,
                            width: width,
                            spinButtons: true,
                            groupSeparator: '.',
                            decimalSeparator: ',',
                            digits: 15, 
                            max: 999999999999999,

                        });
                        break;
                    default:
                        break;
                }
                break;
            default:
                break;
        }
    };

    const handlerSelectFile = () => {
        fileInputRef.current.click();
    };

    const handleFileInput = (event) => {
        // handle validations
        const file = !isNullUndefined(event.target) ? event.target.files[0] : event;
        let flag = false;
        
        if (file) {
            const maxSizeInMB = FILE_MAX_SIZE;
            const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

            if (file.size > maxSizeInBytes) {
                showMessage(setMessageConfigUploadMassive, true, __MessageTypes.WARNING, t('data-lang-msg-filesizeerror'))    

                setSelectedFile(file);
                setProcessedFile(null);
            }
            else {
                if (!file.name.endsWith('.xlsx') && !file.name.endsWith('.xls')) {
                    setSelectedFile(file);
                    setProcessedFile(null);
                    showMessage(setMessageConfigUploadMassive, true, __MessageTypes.ERROR, t('data-lang-msg-documentoperationerror-1')) 
                }
                else {
                    flag = true;
                    setSelectedFile(file);
                    setProcessedFile(null);
                    showMessage(setMessageConfigUploadMassive, false, __MessageTypes.WARNING, '')  
                }
            }
        }

        return flag;
    };

    const downloadErrorFile = () => {
        const byteCharacters = atob(processedFile);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `Payload ${"EdP"} ${moment().format("YYYYMMDD")} Processed File.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handlerUploadFile = async () => {
        //const formData = new FormData();
        //formData.append('file', selectedFile);
        //formData.append("id", enum__BULK_PAYLOAD_TYPE_ID.EDP);
        //formData.append("url", 'Bulk/uploadPayload/nuevo');
        if (inputParam_ElementId !== null) {
            if (selectedFile !== null) {
                if (handleFileInput(selectedFile)) {
                    setUploadInProgress(true);
                    await envDocumentGetUrl('Bulk/uploadPayload/nuevo', enum__BULK_PAYLOAD_TYPE_ID.EDP, selectedFile.name).then(async (responseGetUrl) => {
                        if (responseGetUrl.data.succeeded === true) {
                            await envBlobDocumentUpload(responseGetUrl.data.data.url, responseGetUrl.data.data.fileName, selectedFile).then(async (responseAzure) => {
                                if (responseAzure.data === "" && responseAzure.status === 201) {
                                    await envDocumentValidate(responseGetUrl.data.data.document_id).then(async (responseValidate) => {
                                        if (responseValidate.data.succeeded === true) {
                                            if (responseValidate.data.data.result_validate === true) {
                                                setDocumentId(responseGetUrl.data.data.document_id)
                                                setFileUploaded(true);

                                                if (responseGetUrl.data.data.document_id !== null) {
                                                    await postValidateEdPDocument(responseGetUrl.data.data.document_id, inputParam_ElementId).then(async (serviceResponseProcess) => {
                                                        if (serviceResponseProcess.data.succeeded) {
                                                            if (serviceResponseProcess.data.data.result) {
                                                                setSelectedFile(null)
                                                                fileInputRef.current.value = '';
                                                                setDocumentId(null)
                                                                setProcessedFile(null);

                                                                dispatch(action_updateEdPPrepareForceGetParties(true));

                                                                showMessage(setMessageConfigUploadMassive, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))    
                                                            }
                                                            else {
                                                                if (serviceResponseProcess.data.data.l_result_validation.length > 0) {
                                                                    setProcessedFile(serviceResponseProcess.data.data.l_result_validation[0]);
                                                                    showMessage(setMessageConfigUploadMassive, true, __MessageTypes.ERROR, t('data-lang-msg-templateerror'))
                                                                }
                                                                else {
                                                                    await envDocumentValidate(responseGetUrl.data.data.document_id, 0).then(async () => {
                                                                        showMessage(setMessageConfigUploadMassive, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                                                        setUploadInProgress(false);
                                                                    })
                                                                    .catch((error) => {
                                                                        showMessage(setMessageConfigUploadMassive, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                                                        setUploadInProgress(false);
                                                                    });
                                                                }
                                                            }
                                                            setUploadInProgress(false);
                                                            setFileUploaded(false)
                                                        }
                                                        else {
                                                            showMessage(setMessageConfigUploadMassive, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                                            setUploadInProgress(false);
                                                            setFileUploaded(false)
                                                        }
                                                    }).catch((error) => {
                                                        if (error.response) {
                                                            const statusCode = error.response.status;
                                                            
                                                            if (statusCode === 504) {
                                                                console.log('Error 504: Gateway Timeout - El servidor no respondió a tiempo');
                                                                showMessage(setMessageConfigUploadMassive, true, __MessageTypes.WARNING, t('data-lang-msg-operationerror-bulkuploadtimeout'))
                                                            } else if (statusCode === 499) {
                                                                console.log('Error 499: Client Closed Request - El cliente cerró la conexión antes de la respuesta');
                                                                showMessage(setMessageConfigUploadMassive, true, __MessageTypes.WARNING, t('data-lang-msg-operationerror-bulkuploadtimeout'))
                                                            } else {
                                                                showMessage(setMessageConfigUploadMassive, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                                            }
                                                        } else if (error.request) {
                                                            showMessage(setMessageConfigUploadMassive, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                                        } else {
                                                            showMessage(setMessageConfigUploadMassive, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                                        }
                                    
                                                        setUploadInProgress(false);
                                                        setFileUploaded(false)
                                                    });
                                                }
                                                else {
                                                    showMessage(setMessageConfigUploadMassive, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                                    setUploadInProgress(false);
                                                }
                                                setUploadInProgress(false);
                                            }
                                            else {
                                                showMessage(setMessageConfigUploadMassive, true, __MessageTypes.ERROR, t(responseValidate.data.data.result_validate_msg))
                                                setUploadInProgress(false);
                                            }
                                        }
                                        else {
                                            showMessage(setMessageConfigUploadMassive, true, __MessageTypes.ERROR, t(responseValidate.data.message))
                                            setUploadInProgress(false);
                                        }
                                    })
                                    .catch((error) => {
                                        showMessage(setMessageConfigUploadMassive, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                        setUploadInProgress(false);
                                    });
                                }
                                else {
                                    showMessage(setMessageConfigUploadMassive, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                    setUploadInProgress(false);
                                }
                            })
                            .catch(async (error) => {
                                await envDocumentValidate(responseGetUrl.data.data.document_id, 0).then(async () => {
                                    showMessage(setMessageConfigUploadMassive, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                    setUploadInProgress(false);
                                })
                                .catch((error) => {
                                    showMessage(setMessageConfigUploadMassive, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                    setUploadInProgress(false);
                                });
                            });
                        } else {
                            showMessage(setMessageConfigUploadMassive, true, __MessageTypes.ERROR, t(responseGetUrl.data.message))
                            setUploadInProgress(false);
                        }
                        setSelectedFile(null);
                    })
                    .catch(() => {
                        showMessage(setMessageConfigUploadMassive, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                        setUploadInProgress(false);
                    });
                }
                else {
                    if (!selectedFile.name.endsWith('.xlsx') && !selectedFile.endsWith('.xls')) {
                        showMessage(setMessageConfigUploadMassive, true, __MessageTypes.ERROR, t('data-lang-msg-documentoperationerror-1')) 
                    }
                    else {
                        showMessage(setMessageConfigUploadMassive, true, __MessageTypes.WARNING, t('data-lang-msg-filesizeerror'))
                    }
                }
            }
            else {
                showMessage(setMessageConfigUploadMassive, true, __MessageTypes.ERROR, t('data-lang-msg-selectfile'))
                setUploadInProgress(false);
            }
        }
        else {
            showMessage(setMessageConfigUploadMassive, true, __MessageTypes.ERROR, t('data-lang-msg-selectcontract'))
            setUploadInProgress(false);
        }
    };

    const handlerExportTemplate = async () => {
        if (inputParam_ElementId !== null) {

            await getEdPPayload(inputParam_ElementId, inputParam_EdPId).then(async (serviceResponse) => {
                if (serviceResponse.data.length > 0) {
                    const response = serviceResponse.data;
    
                    response.forEach(file => {
                        const byteCharacters = atob(file);
                        const byteNumbers = new Array(byteCharacters.length);
                        for (let i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }
                        const byteArray = new Uint8Array(byteNumbers);
                        const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                
                        const link = document.createElement('a');
                        link.href = URL.createObjectURL(blob);
                        link.download = `Payload ${"EdP"} ${moment().format("YYYYMMDD")}.xlsx`;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    });
                    setProcessedFile(null);
                    showMessage(setMessageConfigUploadMassive, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))    
                }
                else {
                    showMessage(setMessageConfigUploadMassive, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
            }).catch(() => {
                showMessage(setMessageConfigUploadMassive, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            });
        }
        else {
            showMessage(setMessageConfigUploadMassive, true, __MessageTypes.ERROR, t('data-lang-msg-selectcontract'))
        }
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            const grid = gridRefCantidadServicios.current;
            if (grid) {
                const filtergroup = new window.jqx.filter();
                const filtro = ["C1", "C2", "C3"];
                const filtercondition = "equal";
    
                filtro.forEach(value => {
                    const filter = filtergroup.createfilter("stringfilter", value, filtercondition);
                    filtergroup.addfilter(1, filter);
                });
    
                grid.addfilter("clase", filtergroup);
                grid.applyfilters();
            }
        }, 10);
    
        return () => clearTimeout(timer);
    }, [selectedPivotKey]);

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isBlocking={true}
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-boxname-ingresodatosedp') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.large }
                type={ PanelType.large }
            >
                <Row>
                    <Col xs={12}>
                        <Row>
                            <Col>
                                <div className="d-none">
                                    <TooltipHost content={
                                        <>
                                            <div>{'Tool TIP Archivos Permitidos: "7z", "doc", "docx", "eml", "jpeg", "jpg", "msg", "ods", "pdf", "png", "ppt", "pptx", "rar", "txt", "xls", "xlsb", "xlsx", "xps", "zip“. Peso: 80mb.'}</div>
                                            <div>{'Si tiene problemas con estos formatos, sugerimos guardar nuevamente el archivo con un programa estándar, ejemplo: Archivo de imagen “.jpg”  o “.png” utilizar abrir en “Paint” y volver a guardar.'}</div>
                                        </>
                                    }>
                                        <input ref={fileInputRef} type="file" accept=".xlsx" onChange={handleFileInput} />
                                    </TooltipHost>
                                </div>
                                <div className="d-flex justify-content-end">
                                    <div className="px-1"><ActionButton id="btnGetTemplate" iconProps={{iconName: "Download"}} text={t('data-lang-btn-bulk-gettemplate')} onClick={handlerExportTemplate} /></div>
                                    {
                                        uploadInProgress &&
                                        <div className="px-1">
                                            <Loading
                                                inputParam_ShowLoading={true}
                                                inputParam_ShowText={false}
                                                inputParam_Width={'35px'}
                                                inputParam_Height={'35px'}
                                                inputParam_Left={""}
                                                inputParam_Style={{marginTop: 0}}
                                                inputParam_ColClassName={"me-2"}
                                                inputParam_MarginLeft={"auto"}
                                                inputParam_SpinnerSize={SpinnerSize.medium} />
                                        </div>
                                    }
                                    {
                                        !uploadInProgress &&
                                        <>
                                            <div className="px-1">
                                                <ActionButton 
                                                    id="btnSelectFile"
                                                    styles={{root: {color: (selectedFile !== null ? "green" : undefined)}}} 
                                                    iconProps={{iconName: (selectedFile !== null ? (fileUploaded ? "Attach" : "SkypeCircleCheck") : "Attach")}}
                                                    text={selectedFile !== null ? (fileUploaded ? t('data-lang-btn-bulk-attachtemplate') : selectedFile.name) : t('data-lang-btn-bulk-attachtemplate')} 
                                                    onClick={handlerSelectFile} />
                                            </div>
                                            <div className="px-1"><ActionButton id="btnUploadFile" iconProps={{iconName: "Upload"}} text={t('data-lang-btn-bulk-uploadandprocesstemplate')} onClick={handlerUploadFile} /></div>
                                        </>
                                    }
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <MessageBox
                                    inputParam_Message={ messageConfigUploadMassive.message }
                                    inputParam_Display={ messageConfigUploadMassive.showMessage }
                                    inputParam_MessageType={ messageConfigUploadMassive.messageType }
                                    inputParam_SetterMessage={ setMessageConfig }
                                    inputParam_MessageLink={processedFile !== null ? "Link" : null}
                                    inputParam_MessageLinkFunction={processedFile !== null ? () => downloadErrorFile() : null}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col className='col-auto ms-auto'>
                                {
                                    edpPrepareHeader && edpPrepareHeader._SHOW_NRO_EP &&
                                    <div>
                                        <CTextBox labelText={t('data-lang-lbl-nroep')} controlValue={nroEp} setterControlValue={setterNumeroEp} />
                                    </div>
                                }
                                {
                                    /*edpPrepareHeader && edpPrepareHeader._SHOW_FECHA_HASTA &&
                                    <div className='d-flex'>
                                        <CLabel labelText={t('data-lang-lbl-adjustmentdate')} />
                                        <DatePicker
                                            value={fechaTipoCambio !== null ? new Date(fechaTipoCambio) : null}
                                            onSelectDate={handleDateChange}
                                            placeholder="Select a date"
                                            styles={{ root: { width: '200px' } }}
                                        />
                                    </div>*/
                                }
                            </Col>
                            <Col>
                            </Col>
                        </Row>
                        <div>
                            {
                                edpPrepareAmbiente &&
                                <Pivot styles={{root: {whiteSpace: "normal !important"}}} onLinkClick={onSelectPivotKey} selectedKey={selectedPivotKey} defaultSelectedKey="0">
                                    <PivotItem headerText={ t('data-lang-lbl-cantidadpago') }>
                                        <JqxGrid
                                            ref={gridRefPartidas}
                                            altrows={true}
                                            enabletooltips={true}
                                            width={'100%'}
                                            theme={'light'} 
                                            autoheight={true}
                                            editable={true}
                                            editmode='selectedcell'
                                            selectionmode='singlecell'
                                            pageable={false}
                                            sortable={false}
                                            filterable={false}
                                            showfilterrow={false} 
                                            localization={getGridLocalization(t)}
                                            source={ new jqx.dataAdapter({
                                                localData: edpPrepareParties,
                                                dataType: 'array',
                                                dataFields: [
                                                    { name: 'id',                        type: 'number' },
                                                    { name: 'codigo',                    type: 'string' },
                                                    { name: 'clase',                     type: 'string' },
                                                    { name: 'nombre',                    type: 'string' },
                                                    { name: 'unidad',                    type: 'string' },
                                                    { name: 'cantidaD_CONCEPTO_PAGO_EP', type: 'decimal' },
                                                    { name: 'factoR_REAJUSTE_EP',        type: 'decimal' },
                                                    { name: 'caN_EDIT',                  type: 'bool'    },
                                                ],
                                                id: 'id'
                                            })}
                                            columns={[
                                                { index: null, text: 'ID',                              dataField: 'id',                        width: '0%',  columntype: 'textbox',     editable: false, hidden: true },
                                                { index: 0,    text: t('data-lang-lbl-code'),           dataField: 'codigo',                    width: '8%',  columntype: 'textbox',     editable: false,
                                                    cellsrenderer: (row, column, value) => {
                                                        if (edpPrepareParties[row].subpartidA_ID === null) {
                                                            return `<div class='cellblocked' style="height: 100%; display: flex;pointer-events: none;">${value}</div>`;
                                                        }
                                                        else if (edpPrepareParties[row].subpartidA_ID !== null) {
                                                            return `<div style="background-color: #F4EAA6 !important; height: 100%; display: flex;pointer-events: none;">${value}</div>`;
                                                        } 
                                                        return value.toString();
                                                    },
                                                },
                                                { index: 1,    text: t('data-lang-lbl-class'),          dataField: 'clase',                     width: '5%',  columntype: 'textbox',     editable: false,
                                                    cellsrenderer: (row, column, value) => {
                                                        if (edpPrepareParties[row].subpartidA_ID === null) {
                                                            return `<div class='cellblocked' style="height: 100%; display: flex;pointer-events: none;">${value}</div>`;
                                                        }
                                                        else if (edpPrepareParties[row].subpartidA_ID !== null) {
                                                            return `<div style="background-color: #F4EAA6 !important; height: 100%; display: flex;pointer-events: none;">${value}</div>`;
                                                        }
                                                        return value.toString();
                                                    }
                                                },
                                                { index: 2,    text: t('data-lang-lbl-name'),           dataField: 'nombre',                    width: '49%', columntype: 'textbox',     editable: false,
                                                    cellsrenderer: (row, column, value) => {
                                                        if (edpPrepareParties[row].subpartidA_ID === null) {
                                                            return `<div class='cellblocked' style="height: 100%; display: flex;pointer-events: none;">${value}</div>`;
                                                        }
                                                        else if (edpPrepareParties[row].subpartidA_ID !== null) {
                                                            return `<div style="background-color: #F4EAA6 !important; height: 100%; display: flex;pointer-events: none;">${value}</div>`;
                                                        } 
                                                        return value.toString();
                                                    }
                                                },
                                                { index: 3,    text: t('data-lang-lbl-unidad'),         dataField: 'unidad',                    width: '8%',  columntype: 'textbox',     editable: false,
                                                    cellsrenderer: (row, column, value) => {
                                                        if (edpPrepareParties[row].subpartidA_ID === null) {
                                                            return `<div class='cellblocked' style="height: 100%; display: flex;pointer-events: none;">${value}</div>`;
                                                        }
                                                        else if (edpPrepareParties[row].subpartidA_ID !== null) {
                                                            return `<div style="background-color: #F4EAA6 !important; height: 100%; display: flex;pointer-events: none;">${value}</div>`;
                                                        } 
                                                        return value.toString();
                                                    }
                                                },
                                                { index: 4,    text: t('data-lang-lbl-cantidadpago'),   dataField: 'cantidaD_CONCEPTO_PAGO_EP', width: '15%', columntype: 'textbox',
                                                    //editable: true,
                                                    editable: ((edpPrepareHeader.autofacturacion ? edpPrepareHeader.es_ato : edpPrepareHeader.es_aec) || (contextSite.securityProps.isSAdmin || contextSite.securityProps.isAdmin)),
                                                    cellclassname: "text-end", cellsformat: 'd10', cellsalign: 'right',
                                                    initeditor: function (row, cellvalue, editor, celltext, pressedChar) {
                                                        editor.on('paste', function (event) {
                                                            event.preventDefault();
                                                            let text = (event.originalEvent || event).clipboardData.getData('text');
                                                    
                                                            if (!isNaN(parseFloat(text))) {
                                                                text = text.replace(/\./g, '');
                                                                editor.val(text);
                                                            }
                                                        });
                                                    },
                                                    createeditor: function (row, cellValue, editor, celltext, cellwidth, cellheight) {
                                                        editor.jqxNumberInput({
                                                            spinMode: 'simple',
                                                            width: cellwidth,
                                                            spinButtons: false,
                                                            symbol: '$',
                                                            groupSeparator: '.',
                                                            decimalSeparator: ',',
                                                            digits: 15, 
                                                            decimalDigits: numberValidDecimals,
                                                            max: 999999999999999,
                                                        });
                                                    },
                                                    cellvaluechanging: (row, datafield, columntype, oldvalue, newvalue) => {
                                                        if (edpPrepareParties[row].caN_EDIT === true) {
                                                            if (datafield === 'cantidaD_CONCEPTO_PAGO_EP' && (edpPrepareParties[row].clase === 'C3' || edpPrepareParties[row].clase === 'C5')) {
                                                                return '';
                                                            }

                                                            const aux_newvalue = newvalue.replace(/\./g, '').replace(/\,/g, '.');

                                                            if (aux_newvalue < 0) {
                                                                return oldvalue;
                                                            }
                                                
                                                            if (aux_newvalue !== '' && !isNaN(aux_newvalue)) {
                                                                return newvalue.replace(/\./g, '');
                                                            }
                                                        }
                                                        
                                                        return oldvalue;
                                                    },
                                                    cellsrenderer: (row, column, value) => {
                                                        const finalValue = isNullUndefinedOrEmpty(value) ? value : formatNumber(value, numberValidDecimals)
                                                        if (edpPrepareParties[row].subpartidA_ID === null && column === 'cantidaD_CONCEPTO_PAGO_EP' && (edpPrepareParties[row].clase === 'C3' || edpPrepareParties[row].clase === 'C5')) {
                                                            return `<div class='cellblocked' style="height: 100%; display: flex;pointer-events: none;"></div>`;
                                                        }
                                                        return `<div class="${edpPrepareParties[row].caN_EDIT === false ? 'cellblocked pt-3 pe-1' : 'pt-3 pe-1'}">${finalValue.toString()}</div>`;
                                                    },
                                                    cellbeginedit: (row, datafield) => {
                                                        if (edpPrepareParties[row].caN_EDIT === true) {
                                                            if (datafield === 'cantidaD_CONCEPTO_PAGO_EP' && (edpPrepareParties[row].clase === 'C3' || edpPrepareParties[row].clase === 'C5')) {
                                                                return false;
                                                            }
                                                        }
                                                        return true;
                                                    }
                                                },
                                                { index: 5,    text: t('data-lang-lbl-factorreajuste'), dataField: 'factoR_REAJUSTE_EP',        width: '15%', columntype: 'textbox', cellsformat: 'd10', editable: edpPrepareAmbiente.ingreso_manual_factor_reajuste, hidden: !(edpPrepareAmbiente.tiene_polinomio || edpPrepareAmbiente.ingreso_manual_factor_reajuste), cellsalign: 'right',
                                                    cellclassname: edpPrepareAmbiente.ingreso_manual_factor_reajuste ? 'text-end' : 'cellblocked text-end',
                                                    initeditor: function (row, cellvalue, editor, celltext, pressedChar) {
                                                        editor.on('paste', function (event) {
                                                            event.preventDefault();
                                                            let text = (event.originalEvent || event).clipboardData.getData('text');
                                                    
                                                            if (!isNaN(parseFloat(text))) {
                                                                text = text.replace(/\./g, '');
                                                                editor.val(text);
                                                            }
                                                        });
                                                    },
                                                    createeditor: function (row, cellValue, editor, celltext, cellwidth, cellheight) {
                                                        editor.jqxNumberInput({
                                                            spinMode: 'simple',
                                                            width: cellwidth,
                                                            spinButtons: false,
                                                            symbol: '',
                                                            groupSeparator: '.',
                                                            decimalSeparator: ',',
                                                            digits: 15, 
                                                            decimalDigits: numberValidDecimals,
                                                            max: 999999999999999,
                                                        });
                                                    },
                                                    cellvaluechanging: (row, datafield, columntype, oldvalue, newvalue) => {
                                                        if (datafield === 'factoR_REAJUSTE_EP' && (edpPrepareParties[row].clase === 'C3' || edpPrepareParties[row].clase === 'C5')) {
                                                            return '';
                                                        }

                                                        const aux_newvalue = newvalue.replace(/\./g, '').replace(/\,/g, '.');

                                                        if (aux_newvalue < 0) {
                                                            return oldvalue;
                                                        }
                                            
                                                        if (aux_newvalue !== '' && !isNaN(aux_newvalue)) {
                                                            return newvalue.replace(/\./g, '');
                                                        }
                                                        return oldvalue;
                                                    },
                                                    cellsrenderer: (row, column, value) => {
                                                        const finalValue = isNullUndefinedOrEmpty(value) ? value : formatNumber(value, numberValidDecimals)
                                                        if (edpPrepareParties[row].subpartidA_ID === null && column === 'factoR_REAJUSTE_EP' && (edpPrepareParties[row].clase === 'C3' || edpPrepareParties[row].clase === 'C5')) {
                                                            return `<div class='cellblocked' style="height: 100%; display: flex;pointer-events: none;"></div>`;
                                                        }
                                                        return `<div class="pt-3 pe-1">${finalValue.toString()}</div>`;
                                                    },
                                                    cellbeginedit: (row, datafield) => {
                                                        if (datafield === 'factoR_REAJUSTE_EP' && (edpPrepareParties[row].clase === 'C3' || edpPrepareParties[row].clase === 'C5')) {
                                                            return false;
                                                        }
                                                        return true;
                                                    }
                                                 },
                                            ]}
                                            onCellvaluechanged={onCellPartidasValueChanged} 
                                        />
                                    </PivotItem>
                                    {/*
                                    <PivotItem headerText={ t('data-lang-lbl-cantidadservicios') }>
                                        <JqxGrid
                                            ref={gridRefCantidadServicios}
                                            altrows={true}
                                            enabletooltips={true}
                                            width={'100%'}
                                            theme={'light'} 
                                            autoheight={true}
                                            editable={true}
                                            pageable={false}
                                            editmode='selectedcell'
                                            selectionmode='singlecell'
                                            sortable={false}
                                            filterable={false}
                                            showfilterrow={false} 
                                            localization={getGridLocalization(t)}
                                            source={ new jqx.dataAdapter({
                                                localData: edpPrepareParties,
                                                dataType: 'array',
                                                dataFields: [
                                                    { name: 'id',                   type: 'number' },
                                                    { name: 'codigo',               type: 'string' },
                                                    { name: 'clase',                type: 'string' },
                                                    { name: 'nombre',               type: 'string' },
                                                    { name: 'unidad',               type: 'string' },
                                                    { name: 'cantidaD_SERVICIO_EP', type: 'decimal' },
                                                ],
                                                id: 'id'
                                            })}
                                            columns={[
                                                { index: null, text: 'ID',                                 dataField: 'id',                   width: '0%',  columntype: 'textbox',     editable: false, hidden: true },
                                                { index: 0,    text: t('data-lang-lbl-code'),              dataField: 'codigo',               width: '10%', columntype: 'textbox',     editable: false, cellclassname: 'cellblocked' },
                                                { index: 1,    text: t('data-lang-lbl-class'),             dataField: 'clase',                width: '8%',  columntype: 'textbox',     editable: false, cellclassname: 'cellblocked' },
                                                { index: 2,    text: t('data-lang-lbl-name'),              dataField: 'nombre',               width: '59%', columntype: 'textbox',     editable: false, cellclassname: 'cellblocked' },
                                                { index: 3,    text: t('data-lang-lbl-unidad'),            dataField: 'unidad',               width: '8%',  columntype: 'textbox',     editable: false, cellclassname: 'cellblocked' },
                                                { index: 4,    text: t('data-lang-lbl-cantidadservicios'), dataField: 'cantidaD_SERVICIO_EP', width: '15%', columntype: 'textbox',
                                                    //editable: true,
                                                    editable: ((edpPrepareHeader.autofacturacion ? edpPrepareHeader.es_ato : edpPrepareHeader.es_aec) || (contextSite.securityProps.isSAdmin || contextSite.securityProps.isAdmin)),
                                                    cellclassname: 'text-end',
                                                    cellsformat: 'd10',
                                                    cellsalign: 'right',
                                                    initeditor: function (row, cellvalue, editor, celltext, pressedChar) {
                                                        editor.on('paste', function (event) {
                                                            event.preventDefault();
                                                            let text = (event.originalEvent || event).clipboardData.getData('text');
                                                    
                                                            if (!isNaN(parseFloat(text))) {
                                                                text = text.replace(/\./g, '');
                                                                editor.val(text);
                                                            }
                                                        });
                                                    },
                                                    createeditor: function (row, cellValue, editor, celltext, cellwidth, cellheight) {
                                                        editor.jqxNumberInput({
                                                            spinMode: 'simple',
                                                            width: cellwidth,
                                                            spinButtons: false,
                                                            symbol: '',
                                                            groupSeparator: '.',
                                                            decimalSeparator: ',',
                                                            digits: 15, 
                                                            decimalDigits: numberValidDecimals,
                                                            max: 999999999999999,
                                                        });
                                                    },
                                                    cellvaluechanging: (row, column, columntype, oldvalue, newvalue) => {
                                                        const aux_newvalue = newvalue.replace(/\./g, '').replace(/\,/g, '.');

                                                        if (aux_newvalue < 0) {
                                                            return oldvalue;
                                                        }
                                            
                                                        if (aux_newvalue !== '' && !isNaN(aux_newvalue)) {
                                                            return newvalue.replace(/\./g, '');
                                                        }
                                                        return oldvalue;
                                                    },
                                                    cellsrenderer: (row, column, value) => {
                                                        return `<div class="pt-3 pe-1">${isNullUndefinedOrEmpty(value) ? "" : parseFloat(value.toFixed(numberValidDecimals)).toLocaleString(i18next.language)}</div>`
                                                    },
                                                },
                                            ]}
                                            onCellvaluechanged={onCellPartidasValueChanged}
                                        />
                                    </PivotItem>
                                    */}
                                    {
                                        edpPrepareAmbiente.permite_ingreso_di && //(edpPrepareAmbiente.l_rol.indexOf(edpPrepareAmbiente.rol_ingreso_di) > -1) &&
                                        <PivotItem headerText={ t('data-lang-lbl-incrementosydeducciones') }>
                                            <JqxGrid
                                                ref={gridRefDI}
                                                altrows={true}
                                                enabletooltips={true}
                                                width={'100%'}
                                                theme={'light'} 
                                                autoheight={true}
                                                editable={true}
                                                pageable={false}
                                                editmode='selectedcell'
                                                selectionmode='singlecell'
                                                sortable={false}
                                                filterable={false}
                                                showfilterrow={false} 
                                                localization={getGridLocalization(t)}
                                                groupable={true}
                                                source={ new jqx.dataAdapter({
                                                    localData: edpPrepareDIs,
                                                    dataType: 'array',
                                                    dataFields: [
                                                        { name: 'id',       type: 'number' },
                                                        { name: 'tipo',     type: 'number' },
                                                        { name: 'nombre',   type: 'string' },
                                                        { name: 'monto',    type: 'decimal'},
                                                        { name: 'caN_EDIT', type: 'bool'   },
                                                    ],
                                                    id: 'id'
                                                })}
                                                columns={[
                                                    { index: null, text: 'ID',                       dataField: 'id',     width: '0%',  columntype: 'textbox', editable: false, hidden: true },
                                                    { index: 0,    text: t('data-lang-lbl-type'),    datafield: 'tipo',   hidden: true },
                                                    { index: 1,    text: t('data-lang-lbl-concept'), dataField: 'nombre', width: '70%', columntype: 'textbox', editable: false, cellclassname: 'cellblocked' },
                                                    { index: 2,    text: t('data-lang-lbl-amount'),  dataField: 'monto',  width: '30%', columntype: 'textbox',
                                                        editable: ((edpPrepareHeader.conF_ROL_INGRESO_DI === "AAD" && edpPrepareHeader.es_aad) || (edpPrepareHeader.conF_ROL_INGRESO_DI === "AEC" && edpPrepareHeader.es_aec) || (edpPrepareHeader.conF_ROL_INGRESO_DI === "") || (contextSite.securityProps.isSAdmin || contextSite.securityProps.isAdmin)),
                                                        cellsformat: 'd10',
                                                        cellclassname: 'text-end',
                                                        cellsalign: 'right',
                                                        createeditor: function (row, cellValue, editor, celltext, cellwidth, cellheight) {
                                                            editor.jqxNumberInput({
                                                                spinMode: 'simple',
                                                                width: cellwidth,
                                                                spinButtons: false,
                                                                symbol: '',
                                                                groupSeparator: '.',
                                                                decimalSeparator: ',',
                                                                digits: 15,
                                                                decimalDigits: numberValidDecimals,
                                                                max: 999999999999999,
                                                            });
                                                        },
                                                        cellvaluechanging: (row, column, columntype, oldvalue, newvalue) => {
                                                            if (edpPrepareDIs[row].caN_EDIT === true) {
                                                                const aux_newvalue = newvalue.replace(/\./g, '').replace(/\,/g, '.');

                                                                if (aux_newvalue < 0) {
                                                                    return oldvalue;
                                                                }
                                                    
                                                                if (aux_newvalue !== '' && !isNaN(aux_newvalue)) {
                                                                    return newvalue.replace(/\./g, '');
                                                                }
                                                            }
                                                            return oldvalue;
                                                        },
                                                        cellsrenderer: (row, column, value) => {
                                                            return `<div class="${edpPrepareDIs[row].caN_EDIT === false ? 'cellblocked pt-3 pe-1' : 'pt-3 pe-1'}">${isNullUndefinedOrEmpty(value) ? "" : parseFloat(value).toFixed(numberValidDecimals).toLocaleString(i18next.language)}</div>`
                                                        },
                                                        cellbeginedit: (row, datafield) => {
                                                            if (edpPrepareDIs[row].caN_EDIT === false) {
                                                                return false;
                                                            }
                                                            return true;
                                                        }
                                                    },
                                                ]}
                                                groups={['tipo']}
                                                showgroupsheader={false}
                                                showgroupmenuitems={false}
                                                groupsrenderer={(text, group, expanded, data) => {
                                                    const tipoTexto = tipoTextoMap(parseInt(group));
                                                    return `${tipoTexto} - ${data.subItems.length} elementos`;
                                                }}
                                                //onCellendedit={restoreGroupStates}
                                                groupsexpandedbydefault={true}
                                                closeablegroups={false}
                                                onCellvaluechanged={onCellDIValueChanged} 
                                            />
                                        </PivotItem>
                                    }
                                </Pivot>
                            }
                        </div>
                    </Col>
                </Row>
            </Panel>
        </div>
    );
};

SidePanelIngresoEdP.propTypes = {
    inputParam_IsPanelOpen: PropTypes.bool.isRequired,
    inputParam_SetterIsPanelOpen: PropTypes.func.isRequired,
};

export default SidePanelIngresoEdP;